module.exports = __webpack_public_path__ + "static/img/unnax.fc4a059e.svg";